import type { ComponentDatabindingApiFactory } from './types'
import { repeaterBindingApi } from './repeaterBindingApi'
import type {
  AdaptedDynamicRepeaterComponent,
} from '../inverted-dependencies/components/dynamicRepeaterAdapter'

export const dynamicRepeaterBindingApi: ComponentDatabindingApiFactory<
  AdaptedDynamicRepeaterComponent
> = (component, connectionConfig, context) => {
  const { datasetApi } = context
  const repeaterApi = repeaterBindingApi(component, connectionConfig, context)

  return {
    ...repeaterApi,
    bind() {
      repeaterApi.bind()

      component.loadMoreButton.onClick(() => {
        datasetApi.loadMore()
      })
    },
  }
}
